import type { IApp, IAppStores } from "../shared-components/AppMaster";

export interface IAppLegal extends IApp {
    stores: ILegalStores;
}

export class AppLegal implements IAppLegal {
    constructor(public readonly stores: ILegalStores) {}
}

export interface ILegalStores extends IAppStores {}
